export const zhCN = {
  languageName: "中文",
  strings: {
    "language.switchLabel": "语言",
    "language.english": "English",
    "language.chinese": "中文",
    "home.hero.title": "花生FPV ｜ Blackbox Explorer 镜像站",
    "welcome.openFile": "打开日志/视频",
    "tooltip.openFile": "从打开日志文件或视频开始",
    "placeholder.jumpTime": "输入时间后跳转",
    "loading.file": "正在读取 {fileName}...",
    "version.current": "当前版本 {version}",
    "error.unsupportedBrowser": "当前浏览器缺少读取日志文件所需的 API。",
    "error.localVideoUnsupported": "抱歉，当前浏览器不支持直接播放本地视频文件。",
    "error.videoLoad": "视频加载失败。",
    "error.chromiumVideoExport": "视频导出仅支持 Chromium 内核浏览器。",
    "workspace.upgrading": "检测到旧版工作区格式，正在升级...",
    "workspace.loaded": "工作区已载入",
    "workspace.empty": "<空>",
    "workspace.editName": "编辑工作区名称",
    "workspace.saveHere": "将当前图表设置保存到此工作区",
    "graph.chooseField": "(选择字段)",
    "graph.graph": "图表",
    "graph.removeGraph": "移除图表",
    "graph.axisLabel": "坐标轴标签",
    "graph.fields": "字段:",
    "graph.name": "名称",
    "graph.smooth": "平滑",
    "graph.expo": "Expo",
    "graph.line": "线宽",
    "graph.color": "颜色",
    "graph.minimum": "最小值",
    "graph.maximum": "最大值",
    "graph.addField": "添加字段",
    "videoExport.title": "导出视频",
    "videoExport.rendering": "正在渲染视频...",
    "videoExport.complete": "视频渲染完成!",
    "videoExport.result": "已渲染 {frameCount} 帧，用时 {duration}",
    "videoExport.calculating": "正在估算...",
    "settings.notEnoughMotors": "当前机型需要的电机数量超过日志里可用的电机数量；日志最多只有 {available} 个电机字段，而所选机型需要 {required} 个。",
    "settings.motor": "电机 {number}",
    "home.blackbox.builtIn": "Blackbox 功能内置于 <a href=\"https://github.com/betaflight/betaflight/releases\" target=\"_blank\" rel=\"noopener noreferrer\">Betaflight</a>，大多数现代飞控都支持记录 Blackbox 日志，例如 HAKRC F405、SpeedyBee F405、Mamba F722 等。",
    "home.blackbox.docs": "想开始记录 Blackbox 日志，可以先看 <a href=\"https://github.com/betaflight/betaflight/blob/master/docs/Blackbox.md\" target=\"_blank\" rel=\"noopener noreferrer\">Betaflight Blackbox 功能文档</a>。",
    "home.blackbox.viewerDocs": "已经有日志文件了？可以查看 <a href=\"https://github.com/betaflight/blackbox-tools/blob/master/Readme.md\" target=\"_blank\" rel=\"noopener noreferrer\">Blackbox 日志查看器文档</a>，了解这个工具的使用方式。",
    "home.blackbox.bugs": "如果你发现查看器有问题，例如打开日志时崩溃，或者有改进建议，可以提交到 <a href=\"https://github.com/betaflight/blackbox-log-viewer/issues\" target=\"_blank\" rel=\"noopener noreferrer\">GitHub issue 跟踪器</a>。",
    "home.tuning.intro": "Blackbox 可以帮你看清飞机的真实表现，用来调校 PID、低通滤波等关键参数。",
    "home.tuning.resources": "调机时可以参考这些资料:",
    "home.tuning.link.pidStart": "Mini quad PID 从入门到完整调校",
    "home.tuning.link.helpThread": "Blackbox 日志分析/求助讨论串",
    "home.tuning.link.betaflightPid": "Betaflight PID 调校文档",
    "home.tuning.link.support": "Betaflight 支持讨论串",
    "home.tuning.link.originalViewer": "Blackbox 发布讨论串（原版查看器）",
    "home.tuning.link.enhancedViewer": "增强版 Blackbox 发布讨论串（当前查看器）",
    "home.tuning.byJoshua": "Joshua Bardwell 发布于 RCGroups.com",
    "home.tuning.onRcgroups": "发布于 RCGroups.com",
    "home.tools.decode": "如果想用 Matlab 等数学工具自行分析日志，可以使用独立的 <a href=\"https://github.com/betaflight/blackbox-tools/\" target=\"_blank\" rel=\"noopener noreferrer\">blackbox_decode 工具</a>，先把日志转换成 CSV 再处理。",
    "home.tools.video": "如果想把日志分享成视频，可以使用顶部的“导出视频”按钮渲染 WebM，也可以用命令行 <a href=\"https://github.com/betaflight/blackbox-tools/\" target=\"_blank\" rel=\"noopener noreferrer\">blackbox_render 工具</a>把日志渲染成一系列 PNG，或者直接录屏记录本查看器的回放。",
  },
  text: {
    "Welcome to the Enhanced Blackbox Explorer!": "欢迎使用增强版 Blackbox Explorer!",
    "This tool allows you to view and analyze logs created by Betaflight's Blackbox feature.": "这个工具用于查看和分析 Betaflight Blackbox 记录的飞行日志。",
    "Open log file/video": "打开日志/视频",
    "Introduction to Blackbox": "Blackbox 入门",
    "Tuning your craft": "调校你的飞机",
    "Other tools": "其他工具",
    "Version": "版本",
    "New Window": "新窗口",
    "Export video...": "导出视频...",
    "Export Workspaces...": "导出工作区...",
    "Export CSV...": "导出 CSV...",
    "Export GPX...": "导出 GPX...",
    "View": "视图",
    "Header": "日志头",
    "Values Table": "数值表",
    "Overlay": "叠加层",
    "Video": "视频",
    "Craft": "机体",
    "Sticks": "摇杆",
    "Analyser": "频谱分析",
    "Map": "地图",
    "Playback": "回放",
    "Speed": "速度",
    "Zoom": "缩放",
    "Time": "时间",
    "Log sync": "日志同步",
    "Sync": "同步",
    "Start Log Here": "从这里开始日志",
    "Smart Sync": "智能同步",
    "Workspace": "工作区",
    "Frequency": "频率",
    "Freq. vs Throttle": "频率 vs 油门",
    "Freq. vs RPM": "频率 vs RPM",
    "Power Spectral Density": "功率谱密度",
    "PSD vs Throttle": "PSD vs 油门",
    "PSD vs RPM": "PSD vs RPM",
    "Error vs Setpoint": "误差 vs Setpoint",
    "Show all filters": "显示全部滤波器",
    "Show only Gyro filters": "只显示 Gyro 滤波",
    "Show only D-Term filters": "只显示 D-Term 滤波",
    "Show only Yaw filters": "只显示 Yaw 滤波",
    "Hide all filters": "隐藏全部滤波器",
    "Auto": "自动",
    "Exp": "导出",
    "Imp": "导入",
    "Clr": "清空",
    "Legend": "图例",
    "Graph setup": "图表设置",
    "Field values": "字段值",
    "Raw value": "原始值",
    "Decoded": "解码值",
    "Statistics": "统计",
    "Min/max values from this log": "当前日志的最小/最大值",
    "Min": "最小",
    "Max": "最大",
    "Mean": "平均",
    "Clear All": "清除全部",
    "Configure graphs": "配置图表",
    "Add graph": "添加图表",
    "Remove all graphs": "移除全部图表",
    "Cancel": "取消",
    "Apply changes": "应用更改",
    "Close": "关闭",
    "Save changes": "保存更改",
    "PID SETTINGS": "PID 设置",
    "PID Values": "PID 数值",
    "PID Sliders": "PID 滑块",
    "Feedforward": "Feedforward",
    "Mode": "模式",
    "Active Values": "当前值",
    "Unknown Header Fields": "未知日志头字段",
    "Export video": "导出视频",
    "Video duration": "视频时长",
    "Video format": "视频格式",
    "Save video": "保存视频",
    "Start": "开始",
    "End": "结束",
    "Entire log": "整段日志",
    "From mark in to mark out": "从 In 标记到 Out 标记",
    "Graph": "图表",
    "Graph 1": "图表 1",
    "Axis label": "坐标轴标签",
    "Fields:": "字段:",
    "Name": "名称",
    "Smooth": "平滑",
    "Expo": "Expo",
    "Line": "线宽",
    "Color": "颜色",
    "Minimum": "最小值",
    "Maximum": "最大值",
    "Add field": "添加字段",
    "Settings": "设置",
    "Shortcuts": "快捷键",
    "<empty>": "<空>",
    "Untitled": "未命名",
    "Stored defaults for all pens": "已保存全部曲线的默认值",
    "Stored defaults for single pen": "已保存单条曲线的默认值",
    "Restored defaults for all pens": "已恢复全部曲线的默认值",
    "Restored defaults for single pen": "已恢复单条曲线的默认值",
    "Smoothing": "平滑",
    "Marker Offset": "标记偏移",
    "SELECT CURVES:": "选择曲线:",
    "FULL RANGE:": "完整范围:",
    "At all global log time": "整个日志时间范围",
    "At local window time": "当前窗口时间范围",
    "At marker time range": "标记时间范围",
    "Back": "返回",
    "SET CURVES TO DEFAULT": "将曲线恢复默认",
    "SET CURVES TO ZERO OFFSET": "将曲线偏移归零",
    "SET MIN MAX VALUES": "设置最小/最大值",
    "TO SELECTED CURVES:": "应用到选中曲线:",
    "SET MIN-MAX VALUES": "应用最小/最大值",
    "SET CURVES TO SAME SCALE": "将曲线设为相同刻度",
    "INPUT ZOOM [%]:": "输入缩放 [%]:",
    "ZOOM IN": "放大",
    "ZOOM OUT": "缩小",
    "Full range": "完整范围",
    "Centered": "居中",
    "Default": "默认",
    "Group curves actions:": "批量曲线操作:",
    "Like this one": "跟随这条曲线",
    "One scale": "统一刻度",
    "Notice": "通知",
    "Go to Release Website": "前往发布页面",
    "Save": "保存",
    "Graph Style Settings": "图表样式设置",
    "Show the gradient background.": "显示渐变背景。",
    "Show the vertical timebar.": "显示垂直时间线。",
    "Dark Mode": "深色模式",
    "Theme": "主题",
    "Auto (follow system setting)": "自动（跟随系统）",
    "Off (always light)": "关闭（始终浅色）",
    "On (always dark)": "开启（始终深色）",
    "User Settings": "用户设置",
    "Craft settings": "机体设置",
    "Sticks settings": "摇杆设置",
    "Analyser settings": "频谱分析设置",
    "Map settings": "地图设置",
    "Watermark settings": "水印设置",
    "Laptimer settings": "计时器设置",
    "Units": "单位",
    "Speed units": "速度单位",
    "Altitude units": "高度单位",
    "Meters": "米",
    "Feet": "英尺",
    "Show units": "显示单位",
    "Show trails": "显示轨迹",
    "Invert yaw": "反转 Yaw",
    "Position": "位置",
    "Size": "大小",
    "Transparency": "透明度",
    "Load image": "加载图片",
    "Keyboard shortcuts": "键盘快捷键",
    "Shortcuts": "快捷键",
    "Description": "说明",
    "Command": "命令",
    "Go to the start or end of the current log.": "跳到当前日志的开头或结尾。",
    "Moves through log backwards and forwards by exactly 100ms.": "按 100ms 精确前后移动日志。",
    "Moves through log backwards and forwards fast.": "快速前后移动日志。",
    "Zoom Log Out and In.": "缩小/放大日志。",
    "Starts / Pauses Log and/or Video": "开始/暂停日志和/或视频",
    "Toggle QuickZoom. Quickly Zoom out to Max and back": "切换 QuickZoom，快速缩到最大范围再返回。",
    "Toggle QuickConfig, Quickly show the configuration dump file (if loaded).": "切换 QuickConfig，快速显示已载入的配置 dump 文件。",
    "Marking, Smart Sync": "标记与智能同步",
    "Save the current time to Bookmark hotkeys 1 through 9": "将当前时间保存到书签快捷键 1 到 9。",
    "Save current graph to PNG file": "将当前图表保存为 PNG 文件。",
    "Adjust Zoom of field in graph by hovering field in legend and scroll": "鼠标悬停图例字段并滚动，可调整该字段在图表中的缩放。",
    "Red": "红色",
    "Cyan": "青色",
    "Yellow": "黄色",
    "Purple": "紫色",
    "Blue": "蓝色",
    "Orange": "橙色",
    "Green": "绿色",
    "Pink": "粉色",
    "Grey": "灰色",
    "Dark Purple": "深紫色",
    "Light Green": "浅绿色",
    "Dark Yellow": "深黄色",
    "Custom graph": "自定义图表",
    "Latest stable version": "最新稳定版",
    "Unstable testing versions": "不稳定测试版",
    "The latest official release is": "最新正式版本:",
    "The latest version is:": "最新版本:",
    "The latest development version is:": "最新开发版本:",
    "The Blackbox can deliver insights on your flight performance that will allow you to tune variables such as your PIDs and": "Blackbox 可以帮你看清飞行表现，用来调校 PID、",
    "low-pass filter settings.": "低通滤波等参数。",
    "For help and instructions on how to tune your craft, please read some of these resources:": "如果需要调机参考，可以阅读这些资料:",
    "If you want to analyze your logs with your own mathematics package (such as Matlab) you can use the separate": "如果想用 Matlab 等数学工具自行分析日志，可以使用独立的",
    "to convert your log file into a CSV file for analysis.": "将日志转换为 CSV 后再分析。",
    "If you want to share your log as a video, you can use the\"export video\" button at the top to render a WebM video, or use": "如果想把日志分享成视频，可以使用顶部的“导出视频”按钮渲染 WebM，也可以使用",
    "tool to turn your log into a series of PNG files, or use a screen recording tool to record the playback of this log viewer.": "将日志渲染成一系列 PNG，或用录屏工具录下本查看器的回放。",
    "PPM Receiver Selected": "已选择 PPM 接收机",
    "In-flight level calibration": "飞行中水平校准",
    "Serial Receiver Selected": "已选择串口接收机",
    "Motor Stop on low throttle": "低油门时电机停转",
    "Servo gimbal": "舵机云台",
    "Enable CPU based serial port": "启用 CPU 模拟串口",
    "GPS device connected": "已连接 GPS 设备",
    "Telemetry Output": "遥测输出",
    "PWM receiver selected": "已选择 PWM 接收机",
    "Controller over MSP": "通过 MSP 控制",
    "ADC RSSI Monitoring": "ADC RSSI 监测",
    "Addressable RGB LED strip support": "可寻址 RGB LED 灯带支持",
    "OLED Screen Display": "OLED 屏幕显示",
    "Forward aux channels to servo outputs": "将 AUX 通道转发到舵机输出",
    "Race Transponder": "比赛计时发射器",
    "Battery Monitoring": "电池监测",
    "Battery current monitoring": "电池电流监测",
    "Failsafe mode enabled": "Failsafe 模式已启用",
    "Blackbox flight data recorder": "Blackbox 飞行数据记录器",
    "Airmode always enabled, set off to use modes": "Airmode 始终启用；关闭后可使用模式开关",
    "Super Expo Mode": "Super Expo 模式",
    "Oneshot 125 Enabled": "Oneshot 125 已启用",
    "On Screen Display": "OSD 屏显",
    "Use KISS ESC 24A telemetry as sensor": "使用 KISS ESC 24A 遥测作为传感器",
    "Temporary boost I-Term on high throttle changes": "大油门变化时临时增强 I-Term",
    "Dynamic gyro notch filtering": "动态 Gyro notch 滤波",
    "All axis PID values": "所有轴的 PID 数值",
    "All axis RC Commands": "所有轴的 RC 指令",
    "All axis setpoints": "所有轴的 Setpoint",
    "Vbat and current values": "电池电压和电流值",
    "Barometer and rangefinder": "气压计和测距仪",
    "Filtered gyro data": "滤波后的 Gyro 数据",
    "Attitude data": "姿态数据",
    "Raw accelerometer data": "加速度原始数据",
    "Debug values": "Debug 数值",
    "Motors and tricopter servo values": "电机和三轴机尾舵数值",
    "All GPS-related values": "所有 GPS 相关数值",
    "Angular velocity for all motors": "所有电机的角速度",
    "Unfiltered gyro data": "未滤波 Gyro 数据",
    "All servo output values": "所有舵机输出值",
  },
  attributes: {
    "Start by opening a log or video file": "从打开日志文件或视频开始",
    "Goto the latest version download page": "前往最新版本下载页",
    "Open a new Blackbox Log Viewer window": "打开新的 Blackbox 日志查看器窗口",
    "Export your video and chart setup to file": "将视频和图表设置导出到文件",
    "Export your workspace configurations to file": "将工作区配置导出到文件",
    "Export your current graphs to CSV file": "将当前图表导出为 CSV 文件",
    "Export your flight to GPX file": "将飞行轨迹导出为 GPX 文件",
    "Open another log file, video file, exported workspace file or configuration dump file": "打开另一个日志、视频、工作区导出文件或配置 dump 文件",
    "Zoom In Window": "放大窗口",
    "Zoom Out Window": "缩小窗口",
    "Show Settings": "显示设置",
    "Show Shortcuts": "显示快捷键",
    "View/hide header": "显示/隐藏日志头",
    "View/hide statistics display": "显示/隐藏统计表",
    "View/hide video display": "显示/隐藏视频",
    "View/hide craft display": "显示/隐藏机体",
    "View/hide stick display": "显示/隐藏摇杆",
    "View/hide stick analyser": "显示/隐藏摇杆分析",
    "View/hide analyser display": "显示/隐藏频谱分析",
    "View/hide map": "显示/隐藏地图",
    "View graph": "查看图表",
    "View log header": "查看日志头",
    "View table": "查看表格",
    "Jump to start of video": "跳到视频开头",
    "Jump to start of log": "跳到日志开头",
    "Jump back": "后退",
    "Play/Pause log/video": "播放/暂停日志和视频",
    "Jump forward": "前进",
    "Jump to end of log": "跳到日志结尾",
    "Jump to end of video": "跳到视频结尾",
    "Directly set the playback speed": "直接设置回放速度",
    "Directly set the zoom level": "直接设置缩放级别",
    "Enter a time to jump to": "输入时间后跳转",
    "Move log earlier": "让日志更早",
    "Move log later": "让日志更晚",
    "Enter a time offset": "输入时间偏移",
    "Set the log start to this video frame": "把日志起点同步到当前视频帧",
    "Set the marked position to here...": "将标记位置同步到这里...",
    "Start log here": "从这里开始日志",
    "Type of Spectrum": "频谱类型",
    "Show Filters": "显示滤波器",
    "Spectrum comparison": "频谱对比",
    "Export spectrum to CSV": "导出频谱 CSV",
    "Import spectrum from CSV": "导入频谱 CSV",
    "Clear imported spectrums": "清空已导入频谱",
    "Zoom Analyser Window": "缩放频谱分析窗口",
    "Show the legend": "显示图例",
    "Hide the legend": "隐藏图例",
    "Expo On/Off": "Expo 开/关",
    "Smoothing On/Off": "平滑开/关",
    "Grid On/Off": "网格开/关",
    "Setup chart pens": "设置图表曲线",
    "Value to plot": "要绘制的值",
    "Close without saving changes": "关闭且不保存更改",
    "Close and save changes": "关闭并保存更改",
    "Close the dialog box": "关闭对话框",
    "Cancel video generation": "取消视频生成",
    "Save current graph setup to this Workspace": "将当前图表设置保存到此工作区",
    "Edit Workspace Name": "编辑工作区名称",
  },
  fieldTerms: {
    "PID P": "PID P",
    "PID I": "PID I",
    "PID D": "PID D",
    "PID Feedforward": "PID Feedforward",
    "PID Sum": "PID 总和",
    "PID Error": "PID 误差",
    Setpoints: "Setpoint",
    Setpoint: "Setpoint",
    "RC Commands": "RC 指令",
    "RC Command": "RC 指令",
    Gyros: "Gyro",
    Gyro: "Gyro",
    "Unfiltered Gyros": "未滤波 Gyro",
    "Unfiltered Gyro": "未滤波 Gyro",
    Motors: "电机",
    Motor: "电机",
    Servos: "舵机",
    Servo: "舵机",
    "Servo Tail": "尾舵机",
    "Battery volt.": "电池电压",
    "Battery Volt": "电池电压",
    Amperage: "电流",
    Barometer: "气压计",
    Heading: "航向",
    "Accel.": "加速度",
    Compass: "磁罗盘",
    "Flight Mode Flags": "飞行模式标志",
    "State Flags": "状态标志",
    "Failsafe Phase": "Failsafe 阶段",
    "RX Signal Received": "已收到 RX 信号",
    "RX Flight Ch. Valid": "RX 飞行通道有效",
    "GPS Sat Count": "GPS 卫星数",
    "GPS Latitude": "GPS 纬度",
    "GPS Longitude": "GPS 经度",
    "GPS Altitude ASL": "GPS 海拔",
    "GPS Speed": "GPS 速度",
    "GPS Heading": "GPS 航向",
    "GPS NED velocities": "GPS NED 速度",
    "North velocity": "北向速度",
    "East velocity": "东向速度",
    "Down velocity": "下向速度",
    "GPS Coords": "GPS 坐标",
    "GPS Home distance": "GPS 返航距离",
    "GPS Home azimuth": "GPS 返航方位角",
    "GPS Traject. tilt angle": "GPS 轨迹倾角",
    Debug: "Debug",
    "Debug Cycle Time": "Debug 循环时间",
    "Cycle Time": "循环时间",
    "CPU Load": "CPU 负载",
    "Motor Update": "电机更新",
    "Motor Deviation": "电机偏差",
    "Not Used": "未使用",
    "Debug Battery": "Debug 电池",
    "Battery Volt ADC": "电池电压 ADC",
    "Debug Gyro": "Debug Gyro",
    "Gyro Raw": "Gyro 原始值",
    "Debug Gyro Filtered": "Debug 滤波后 Gyro",
    "Gyro Filtered": "滤波后 Gyro",
    "Debug Accel.": "Debug 加速度",
    "Accel. Raw": "加速度原始值",
    "Debug Mixer": "Debug Mixer",
    "Roll-Pitch-Yaw Mix": "Roll/Pitch/Yaw 混控",
    "Debug PID": "Debug PID",
    "Wait Time": "等待时间",
    "Sub Update Time": "子更新耗时",
    "PID Update Time": "PID 更新耗时",
    "Motor Update Time": "电机更新耗时",
    "Debug Notch": "Debug Notch",
    "Gyro Pre-Notch": "Notch 前 Gyro",
    "Debug Filter": "Debug 滤波",
    "DTerm Filter": "D-Term 滤波",
  },
};
